import { useTranslation } from "react-i18next";
import { DocumentDownload } from "iconsax-react";
import { ModalWrapper, Button } from "@/shared/ui";

interface Props {
  onClose: () => void;
  onDownloadDocx: () => void;
  onDownloadPdf: () => void;
}

export default function DownloadTimesheetModal({ onClose, onDownloadDocx, onDownloadPdf }: Props) {
  const { t } = useTranslation("TimesheetsPage");

  function handleDownloadDocx() {
    onDownloadDocx();
    onClose();
  }

  function handleDownloadPdf() {
    onDownloadPdf();
    onClose();
  }

  return (
    <ModalWrapper onClose={onClose}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2 pb-4 border-b surface-component-stroke">
          <div className="flex items-center gap-3">
            <DocumentDownload size={24} color="currentColor" className="content-base-primary" />
            <h4 className="text-display-2xs content-base-primary">{t("downloadModal.title")}</h4>
          </div>
          <p className="text-body-regular-sm content-base-secondary">{t("downloadModal.description")}</p>
        </div>
        <div className="flex flex-col gap-2">
          <Button variant="secondary" size="md" onClick={handleDownloadDocx} className="w-full justify-start">
            {t("downloadModal.downloadDocx")}
          </Button>
          <Button variant="secondary" size="md" onClick={handleDownloadPdf} className="w-full justify-start">
            {t("downloadModal.downloadPdf")}
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
}
